import api from './axios'

function extrairErro(error, fallback) {
  return (
    error?.response?.data?.mensagem ||
    error?.response?.data?.message ||
    error?.message ||
    fallback
  )
}

export async function listarNotificacoesWhatsapp() {
  const resp = await api.get('/notificacao-whatsapp')
  return resp.data?.mensagens || []
}

export async function criarNotificacaoWhatsapp(formData) {
  const resp = await api.post('/notificacao-whatsapp', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return resp.data?.mensagem
}

export async function atualizarNotificacaoWhatsapp(id, formData) {
  const resp = await api.put(`/notificacao-whatsapp/${id}`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return resp.data?.mensagem
}

export async function excluirNotificacaoWhatsapp(id) {
  const resp = await api.delete(`/notificacao-whatsapp/${id}`)
  return resp.data
}

export async function dispararNotificacaoWhatsapp(id) {
  const resp = await api.post(`/notificacao-whatsapp/${id}/disparar`)
  return resp.data
}

export async function listarEnviosNotificacaoWhatsapp(id) {
  const resp = await api.get(`/notificacao-whatsapp/${id}/envios`)
  return resp.data?.envios || []
}

export async function disparoRapidoWhatsapp({
  mensagem,
  numero,
  id_usuario,
  id_template,
  placeholders,
}) {
  try {
    const resp = await api.post('/notificacao-whatsapp/disparo-rapido', {
      mensagem: mensagem || undefined,
      numero: numero || undefined,
      id_usuario: id_usuario || undefined,
      id_template: id_template || undefined,
      placeholders: placeholders ? JSON.stringify(placeholders) : undefined,
    })
    return resp.data
  } catch (error) {
    throw new Error(extrairErro(error, 'Erro no disparo rápido'))
  }
}

export async function listarTemplatesWhatsapp() {
  const resp = await api.get('/notificacao-whatsapp/templates')
  const templates = resp.data?.templates || []
  return [...templates].sort((a, b) => {
    const da = new Date(a.createdAt || a.created_at || 0).getTime()
    const db = new Date(b.createdAt || b.created_at || 0).getTime()
    if (db !== da) return db - da
    return (b.id || 0) - (a.id || 0)
  })
}

export async function criarTemplateWhatsapp(formData) {
  try {
    const resp = await api.post('/notificacao-whatsapp/templates', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    return resp.data?.template
  } catch (error) {
    throw new Error(extrairErro(error, 'Erro ao criar template'))
  }
}

export async function submeterTemplateWhatsapp(id) {
  try {
    const resp = await api.post(`/notificacao-whatsapp/templates/${id}/submeter`)
    return resp.data?.template
  } catch (error) {
    throw new Error(extrairErro(error, 'Erro ao submeter template'))
  }
}

export async function sincronizarTemplateWhatsapp(id) {
  try {
    const resp = await api.post(`/notificacao-whatsapp/templates/${id}/sincronizar`)
    return resp.data?.template
  } catch (error) {
    throw new Error(extrairErro(error, 'Erro ao sincronizar template'))
  }
}

export async function importarTemplatesTwilio() {
  try {
    const resp = await api.post('/notificacao-whatsapp/templates/importar-twilio')
    return resp.data
  } catch (error) {
    throw new Error(extrairErro(error, 'Erro ao importar templates da Twilio'))
  }
}

export function renderPreviewPlaceholders(texto, usuario, valoresCustom) {
  if (!texto) return ''
  const map = {
    NOME: usuario?.nome || 'Nome do convidado',
    TIPO: usuario?.tipo || 'convidado',
    EMPRESA: usuario?.empresa || 'Empresa',
    CARGO: usuario?.cargo || 'Cargo',
    EMAIL: usuario?.email || 'email@exemplo.com',
    CELULAR: usuario?.celular || '11999999999',
  }
  if (valoresCustom && typeof valoresCustom === 'object') {
    Object.entries(valoresCustom).forEach(([k, v]) => {
      if (v != null && String(v).trim() !== '') {
        map[String(k).toUpperCase()] = String(v)
      }
    })
  }
  return String(texto).replace(/\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}/g, (_m, key) => {
    return map[String(key).toUpperCase()] ?? ''
  })
}

export function extrairPlaceholdersTemplate(template) {
  if (!template) return []
  const fromMap = Object.keys(template.variaveisMap || template.variaveis_map || {}).map((k) =>
    String(k).toUpperCase()
  )
  const fromCorpo = [
    ...(String(template.corpo || '').matchAll(/\{\{\s*([A-Za-z_][A-Za-z0-9_]*)\s*\}\}/g) || []),
  ].map((m) => String(m[1]).toUpperCase())
  return [...new Set([...fromMap, ...fromCorpo])]
}

export function valoresPlaceholderDoUsuario(usuario) {
  if (!usuario) return {}
  return {
    NOME: usuario.nome || '',
    TIPO: usuario.tipo || '',
    EMPRESA: usuario.empresa || '',
    CARGO: usuario.cargo || '',
    EMAIL: usuario.email || '',
    CELULAR: usuario.celular || '',
  }
}
